import FormItemDateResolver from './FormItemDateResolver';
import FormItemTimeResolver from './FormItemTimeResolver';
export default class FormItemDateTimeResolver
{
    static getResult()
    {
        var dateInput = arguments[0];
        if(!dateInput)return "";

        var reg = /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
        var regExp = new RegExp(reg);
        if(regExp.test(dateInput)){
        　　return dateInput;
        }

        let length = dateInput.length;

        if(length>6)
        {
            let dateStr;let timeStr;
            if(length>12 && length<18)
            {
                dateStr = dateInput.substr(0,8);
                timeStr = dateInput.substring(8);
            }
            else if(length<=12)
            {
                dateStr = dateInput.substr(0,6);
                timeStr = dateInput.substring(6);
            }else{
                dateStr = dateInput.substr(0,10);
                timeStr = dateInput.substring(10);
            }
            let dateResult = FormItemDateResolver.getResult(dateStr);
            if(dateResult.indexOf("false:") == 0)return dateResult;
            let timeResult = FormItemTimeResolver.getResult(timeStr);
            if(timeResult.indexOf("false:") == 0)return timeResult;
            return dateResult+" "+timeResult;
        }
        else
        {
            return FormItemDateResolver.getResult(dateInput);
        }
    }
}


// WEBPACK FOOTER //
// ./src/formItem/resolver/FormItemDateTimeResolver.js